import React from 'react';

import './Header.css';
import LogoTaf from '../../images/logo-taf.png';

function Header() {
  return (
    <header className="header orv">
      <div className="topbar" />
      <div className="contain">
        <a href="/" className="logo">
          <img src={LogoTaf} alt="TAF"/>
        </a>
      </div>
    </header>
  );
}


export default Header;
